import { nutritionFormAdapter } from "../form-adapter";
export const otherNutritionAdapter = nutritionFormAdapter("other");
